import React, { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'

import {
  Btn,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../../components'
import { errorHandler } from '../../../../../services/util/error.service'
import * as ResumoHttp from '../../../../../services/api/https/picking/resumo-separcao.http'
import {
  buildFaltaQuantityInputState,
  getFaltaInputLabels,
  getFaltaQuantityConfig,
  getFaltaQuantityValueFromInputs,
} from '../../../Entrega/Ocorrencias/Falta/falta-volume-and-units.helper'

function getInitialReason(falta, reasons) {
  if (!falta || !falta.missing_reason || !falta.missing_reason.id) return null
  return reasons.find(reason => reason.id === falta.missing_reason.id) || falta.missing_reason
}

function ModalAjusteOcorrenciaFalta({ show, falta, reasons, onClose, onSaved, onError }) {
  const [selectedReason, setSelectedReason] = useState(null)
  const [qte, setQte] = useState('')
  const [volumeValue, setVolumeValue] = useState('')
  const [unitsValue, setUnitsValue] = useState('')
  const [justification, setJustification] = useState('')

  useEffect(() => {
    if (!show || !falta) return

    const nextQuantityState = buildFaltaQuantityInputState(falta, falta.qte_adjusted)

    setSelectedReason(getInitialReason(falta, reasons))
    setQte(nextQuantityState.quantityValue)
    setVolumeValue(nextQuantityState.volumeValue)
    setUnitsValue(nextQuantityState.unitsValue)
    setJustification(falta.adjust_justification || '')
  }, [show, falta, reasons])

  if (!show || !falta) return null

  const { canUseFractionedInput } = getFaltaQuantityConfig(falta)
  const { volumeLabel, unitsLabel } = getFaltaInputLabels(falta)

  const onQuantityChange = (field, value) => {
    const nextVolumeValue = field === 'volume' ? value : volumeValue
    const nextUnitsValue = field === 'units' ? value : unitsValue

    setVolumeValue(nextVolumeValue)
    setUnitsValue(nextUnitsValue)
    setQte(getFaltaQuantityValueFromInputs(falta, nextVolumeValue, nextUnitsValue))
  }

  const onBtnSalvarClicked = async () => {
    if (!selectedReason || !selectedReason.id) {
      onError('Selecione a Ocorrência.')
      return
    }

    const qteAdjusted = Number(qte || 0)
    if (qteAdjusted !== 0 && justification.trim().length < 5) {
      onError('A justificativa deve conter pelo menos 5 caracteres')
      return
    }

    try {
      await ResumoHttp.updateMissingProductSeparacaoAdjustment({
        falta_id: falta.falta_id,
        missing_reason_id: selectedReason.id,
        qte_adjusted: qteAdjusted,
        adjust_justification: justification,
      })
      onSaved()
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  return (
    <CustomModal
      header="Ajuste da Ocorrência"
      isVisible={show}
      onClose={onClose}
      width="min(720px, 94vw)"
    >
      <form>
        <div style={{ display: 'grid', gap: 12, marginBottom: 18 }}>
          <div>
            <span style={{ display: 'block', color: '#14B0BF', fontSize: '0.8rem' }}>Produto</span>
            <strong>
              {falta.product_code ? `${falta.product_code} - ` : ''}
              {falta.product_name || '-'}
            </strong>
          </div>
          <div>
            <span style={{ display: 'block', color: '#14B0BF', fontSize: '0.8rem' }}>
              Alterar Motivo
            </span>
            <Dropdown
              style={{ width: '100%' }}
              optionLabel="name"
              value={selectedReason}
              options={reasons}
              onChange={({ value }) => setSelectedReason(value)}
              placeholder="Selecione a Ocorrência"
            />
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: 12,
            marginBottom: 14,
          }}
        >
          {canUseFractionedInput ? (
            <InputNumeroInteiro
              label={volumeLabel}
              marginTop={0}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          ) : (
            <InputNumeroDecimal
              label={volumeLabel}
              marginTop={0}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          )}
          <InputNumeroInteiro
            label={unitsLabel}
            marginTop={0}
            value={unitsValue}
            onChange={value => onQuantityChange('units', value)}
            disabled={!canUseFractionedInput}
          />
        </div>

        <InputText
          label="Justificativa :"
          marginTop={0}
          value={justification}
          onChange={value => setJustification(value)}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 18 }}>
          <Btn minWidth={null} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalAjusteOcorrenciaFalta
